import { NavHashLink as NavLink } from 'react-router-hash-link'
import { Link as SmoothLink } from 'react-scroll'
import './navitems.scss'
import NousConnaitre from '@pages/NousConnaitre'

export const NavItems = ({ datas }) => {
	const isActive = (path) => {
		return location.pathname.includes(path) ? 'active' : ''
	}
	const _component = {
		NousConnaitre: NousConnaitre
	}
	return datas && datas.length > 0
		? datas
				.filter((i) => i.isNav)
				.map((item) => {
					const { title, slug, component, subRubriques, url, isMobileOnly } =
						item
					const Component = component ? _component[component] : null
					let link = ''
					if (subRubriques.length > 0) {
						link = slug === '' ? 'home' : subRubriques[0].slug
					} else if (typeof url !== undefined) {
						link = url
					} else {
						link = slug
					}

					return (
						<li
							key={slug}
							className={`nav-item ${slug} ${
								isMobileOnly ? 'is-hidden-xl' : ''
							} ${isActive(`/${slug}`)}`}
						>
							{component ? (
								<Component />
							) : slug === 'bilan_financier' ? (
								<a className="nav-link" href={url} target="_blank">
									<span>{title}</span>
								</a>
							) : (
								<NavLink className="nav-link" to={`/${slug}/#${link}`}>
									<span>{title}</span>
								</NavLink>
							)}
							<ul className="subnav">
								{subRubriques &&
									subRubriques.map((item2, index2) => (
										<li key={index2} className={`nav-item`}>
											{slug && isActive(`/${slug}`) ? (
												<SmoothLink
													key={`${item2.slug}`}
													activeClass="active"
													to={`${item2.slug}`}
													spy
													smooth
													hashSpy
													offset={0}
													duration={700}
													className={`nav-link subnav__${item2.slug} `}
												>
													{item2.title}
												</SmoothLink>
											) : (
												<NavLink
													className="nav-link"
													to={`/${slug}/#${item2.slug}`}
												>
													{item2.title}
												</NavLink>
											)}
										</li>
									))}
							</ul>
						</li>
					)
				})
		: ''
}
